"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrimaryAttribute = exports.PRIMARY_ATTRIBUTES = exports.AttributeType = void 0;
var AttributeType;
(function (AttributeType) {
    AttributeType[AttributeType["Health"] = 0] = "Health";
    AttributeType[AttributeType["SpellPoints"] = 1] = "SpellPoints";
    AttributeType[AttributeType["Power"] = 2] = "Power";
    // physicalDamage = baseDamage + power 
    AttributeType[AttributeType["Focus"] = 3] = "Focus";
    // magicDamage = baseDamage + focus
    // ~~healingAmount = baseHealing + focus~~
    AttributeType[AttributeType["Agility"] = 4] = "Agility";
    // @deprecated; 
    // increases haste using scaled log
    // increases dodge using scaled log
    // increases accuracy using scaled log
    AttributeType[AttributeType["Vitality"] = 5] = "Vitality";
    // increase health by 5
    AttributeType[AttributeType["Toughness"] = 6] = "Toughness";
    // increase all damage immunity using scaled log
    AttributeType[AttributeType["Will"] = 7] = "Will";
    // reduces chance for debuffs to stick using scaled log
    // dotDamage = (baseDamage + <attribute>) - will
    // healingAmount = baseHealing + will
    AttributeType[AttributeType["Luck"] = 8] = "Luck";
    // increases loot rarity by x%
    // increases critical strike chance using scaled log
    // gambler abilities
    AttributeType[AttributeType["Accuracy"] = 100] = "Accuracy";
    AttributeType[AttributeType["CriticalStrikeChance"] = 101] = "CriticalStrikeChance";
    AttributeType[AttributeType["CriticalDamageMultiplier"] = 102] = "CriticalDamageMultiplier";
    AttributeType[AttributeType["Armor"] = 103] = "Armor";
    AttributeType[AttributeType["Dodge"] = 104] = "Dodge";
    AttributeType[AttributeType["Haste"] = 107] = "Haste";
    AttributeType[AttributeType["CriticalDamageReductionPercent"] = 108] = "CriticalDamageReductionPercent";
    AttributeType[AttributeType["ExtraActions"] = 109] = "ExtraActions";
    AttributeType[AttributeType["VulnerabilityStacks"] = 200] = "VulnerabilityStacks";
    AttributeType[AttributeType["HasteStacks"] = 202] = "HasteStacks";
    AttributeType[AttributeType["SlowStacks"] = 203] = "SlowStacks";
    AttributeType[AttributeType["RevengeStacks"] = 204] = "RevengeStacks";
    AttributeType[AttributeType["BurnDamageIncrease"] = 300] = "BurnDamageIncrease";
    AttributeType[AttributeType["BleedDamageIncrease"] = 301] = "BleedDamageIncrease";
    AttributeType[AttributeType["ChillDamageIncrease"] = 302] = "ChillDamageIncrease";
    AttributeType[AttributeType["PoisonDamageIncrease"] = 303] = "PoisonDamageIncrease";
    AttributeType[AttributeType["CurseDamageIncrease"] = 304] = "CurseDamageIncrease";
    AttributeType[AttributeType["BurnDamageImmunity"] = 350] = "BurnDamageImmunity";
    AttributeType[AttributeType["BleedDamageImmunity"] = 351] = "BleedDamageImmunity";
    AttributeType[AttributeType["ChillDamageImmunity"] = 352] = "ChillDamageImmunity";
    AttributeType[AttributeType["PoisonDamageImmunity"] = 353] = "PoisonDamageImmunity";
    AttributeType[AttributeType["CurseDamageImmunity"] = 354] = "CurseDamageImmunity";
    AttributeType[AttributeType["AllDamagePercentIncrease"] = 400] = "AllDamagePercentIncrease";
    AttributeType[AttributeType["ChaosDamagePercentIncrease"] = 401] = "ChaosDamagePercentIncrease";
    AttributeType[AttributeType["DeathDamagePercentIncrease"] = 402] = "DeathDamagePercentIncrease";
    AttributeType[AttributeType["FireDamagePercentIncrease"] = 403] = "FireDamagePercentIncrease";
    AttributeType[AttributeType["FrostDamagePercentIncrease"] = 404] = "FrostDamagePercentIncrease";
    AttributeType[AttributeType["HolyDamagePercentIncrease"] = 405] = "HolyDamagePercentIncrease";
    AttributeType[AttributeType["NatureDamagePercentIncrease"] = 406] = "NatureDamagePercentIncrease";
    AttributeType[AttributeType["PhysicalDamagePercentIncrease"] = 407] = "PhysicalDamagePercentIncrease";
    AttributeType[AttributeType["SonicDamagePercentIncrease"] = 408] = "SonicDamagePercentIncrease";
    AttributeType[AttributeType["PercentHealingDecrease"] = 409] = "PercentHealingDecrease";
    AttributeType[AttributeType["PercentHealingReceivedDecrease"] = 410] = "PercentHealingReceivedDecrease";
    AttributeType[AttributeType["PercentHealingIncrease"] = 411] = "PercentHealingIncrease";
    AttributeType[AttributeType["AllDamageResistance"] = 600] = "AllDamageResistance";
    AttributeType[AttributeType["ChaosDamageResistance"] = 601] = "ChaosDamageResistance";
    AttributeType[AttributeType["DeathDamageResistance"] = 602] = "DeathDamageResistance";
    AttributeType[AttributeType["FireDamageResistance"] = 603] = "FireDamageResistance";
    AttributeType[AttributeType["FrostDamageResistance"] = 604] = "FrostDamageResistance";
    AttributeType[AttributeType["HolyDamageResistance"] = 605] = "HolyDamageResistance";
    AttributeType[AttributeType["NatureDamageResistance"] = 606] = "NatureDamageResistance";
    AttributeType[AttributeType["PhysicalDamageResistance"] = 607] = "PhysicalDamageResistance";
    AttributeType[AttributeType["SonicDamageResistance"] = 608] = "SonicDamageResistance";
    AttributeType[AttributeType["AllDamageImmunity"] = 700] = "AllDamageImmunity";
    AttributeType[AttributeType["ChaosDamageImmunity"] = 701] = "ChaosDamageImmunity";
    AttributeType[AttributeType["DeathDamageImmunity"] = 702] = "DeathDamageImmunity";
    AttributeType[AttributeType["FireDamageImmunity"] = 703] = "FireDamageImmunity";
    AttributeType[AttributeType["FrostDamageImmunity"] = 704] = "FrostDamageImmunity";
    AttributeType[AttributeType["HolyDamageImmunity"] = 705] = "HolyDamageImmunity";
    AttributeType[AttributeType["NatureDamageImmunity"] = 706] = "NatureDamageImmunity";
    AttributeType[AttributeType["PhysicalDamageImmunity"] = 707] = "PhysicalDamageImmunity";
    AttributeType[AttributeType["SonicDamageImmunity"] = 708] = "SonicDamageImmunity";
    AttributeType[AttributeType["AbsoluteAllDamageImmunity"] = 800] = "AbsoluteAllDamageImmunity";
    AttributeType[AttributeType["AbsoluteChaosDamageImmunity"] = 801] = "AbsoluteChaosDamageImmunity";
    AttributeType[AttributeType["AbsoluteDeathDamageImmunity"] = 802] = "AbsoluteDeathDamageImmunity";
    AttributeType[AttributeType["AbsoluteFireDamageImmunity"] = 803] = "AbsoluteFireDamageImmunity";
    AttributeType[AttributeType["AbsoluteFrostDamageImmunity"] = 804] = "AbsoluteFrostDamageImmunity";
    AttributeType[AttributeType["AbsoluteHolyDamageImmunity"] = 805] = "AbsoluteHolyDamageImmunity";
    AttributeType[AttributeType["AbsoluteNatureDamageImmunity"] = 806] = "AbsoluteNatureDamageImmunity";
    AttributeType[AttributeType["AbsolutePhysicalDamageImmunity"] = 807] = "AbsolutePhysicalDamageImmunity";
    AttributeType[AttributeType["AbsoluteSonicDamageImmunity"] = 808] = "AbsoluteSonicDamageImmunity";
    AttributeType[AttributeType["None"] = 10000000] = "None";
    // XP Boost
    AttributeType[AttributeType["XP_Boost"] = 900000000] = "XP_Boost";
    // Charm Item Effects
    AttributeType[AttributeType["Charm_Warrior_0"] = 1000000000] = "Charm_Warrior_0";
    AttributeType[AttributeType["Charm_Warrior_1"] = 1000000001] = "Charm_Warrior_1";
    AttributeType[AttributeType["Charm_Vampire_0"] = 100010000] = "Charm_Vampire_0";
    AttributeType[AttributeType["Charm_Vampire_1"] = 100010001] = "Charm_Vampire_1";
    AttributeType[AttributeType["Charm_Valkyrie_0"] = 1000020000] = "Charm_Valkyrie_0";
    AttributeType[AttributeType["Charm_Valkyrie_1"] = 1000020001] = "Charm_Valkyrie_1";
    AttributeType[AttributeType["Charm_HighPriestess_0"] = 1000030000] = "Charm_HighPriestess_0";
    AttributeType[AttributeType["Charm_HighPriestess_1"] = 1000030001] = "Charm_HighPriestess_1";
    AttributeType[AttributeType["Charm_Augur_0"] = 1000040000] = "Charm_Augur_0";
    AttributeType[AttributeType["Charm_Augur_1"] = 1000040001] = "Charm_Augur_1";
    AttributeType[AttributeType["Charm_Assassin_0"] = 1000050000] = "Charm_Assassin_0";
    AttributeType[AttributeType["Charm_Assassin_1"] = 1000050001] = "Charm_Assassin_1";
    AttributeType[AttributeType["Charm_Avenger_0"] = 1000060000] = "Charm_Avenger_0";
    AttributeType[AttributeType["Charm_Avenger_1"] = 1000060001] = "Charm_Avenger_1";
    AttributeType[AttributeType["Charm_Tempest_0"] = 1000070000] = "Charm_Tempest_0";
    AttributeType[AttributeType["Charm_Tempest_1"] = 1000070001] = "Charm_Tempest_1";
    AttributeType[AttributeType["Charm_Executioner_0"] = 1000080000] = "Charm_Executioner_0";
    AttributeType[AttributeType["Charm_Executioner_1"] = 1000080001] = "Charm_Executioner_1";
    AttributeType[AttributeType["Charm_Ranger_0"] = 1000090000] = "Charm_Ranger_0";
    AttributeType[AttributeType["Charm_Ranger_1"] = 1000090001] = "Charm_Ranger_1";
    AttributeType[AttributeType["Charm_Sunbreaker_0"] = 1000100000] = "Charm_Sunbreaker_0";
    AttributeType[AttributeType["Charm_Sunbreaker_1"] = 1000100001] = "Charm_Sunbreaker_1";
    AttributeType[AttributeType["Charm_ThunderCaller_0"] = 1000110000] = "Charm_ThunderCaller_0";
    AttributeType[AttributeType["Charm_ThunderCaller_1"] = 1000110001] = "Charm_ThunderCaller_1";
    AttributeType[AttributeType["Charm_Monk_0"] = 1000120000] = "Charm_Monk_0";
    AttributeType[AttributeType["Charm_Monk_1"] = 1000120001] = "Charm_Monk_1";
    AttributeType[AttributeType["Charm_Gladiator_0"] = 1000130000] = "Charm_Gladiator_0";
    AttributeType[AttributeType["Charm_Gladiator_1"] = 1000130001] = "Charm_Gladiator_1";
    AttributeType[AttributeType["Charm_Gambler_0"] = 1000140000] = "Charm_Gambler_0";
    AttributeType[AttributeType["Charm_Gambler_1"] = 1000140001] = "Charm_Gambler_1";
    AttributeType[AttributeType["Charm_Necromancer_0"] = 1000150000] = "Charm_Necromancer_0";
    AttributeType[AttributeType["Charm_Necromancer_1"] = 1000150001] = "Charm_Necromancer_1";
    AttributeType[AttributeType["Charm_Druid_0"] = 1000160000] = "Charm_Druid_0";
    AttributeType[AttributeType["Charm_Druid_1"] = 1000160001] = "Charm_Druid_1";
})(AttributeType = exports.AttributeType || (exports.AttributeType = {}));
exports.PRIMARY_ATTRIBUTES = new Set([
    AttributeType.Power,
    AttributeType.Focus,
    AttributeType.Vitality,
    AttributeType.Toughness,
    AttributeType.Will,
    AttributeType.Luck
]);
function isPrimaryAttribute(attribute) {
    return exports.PRIMARY_ATTRIBUTES.has(attribute);
}
exports.isPrimaryAttribute = isPrimaryAttribute;
// one or two stats that make it hard to hit you
// one or two stats the reduce damage (flat amount, percent)
// sumof crit chance = (baseModifier + equipmentModifiers + effectModifiers)
// base 5
// equipment 3
// effect 10
// 18%
// damage calculation
// random(.85, 1.15) * (baseDamage + attributeModifiers) * critMultiplier * floor(0, random(0, 1) + critChance)
// crit base is 1.5
// 0 ->  .18 -> 0 * mulitiplier
// 1 -> 1.18 -> 1 * multiplier
// level 50
// 1 * (300 + 100) = 400 * 1.8 = 700 * 10 = 7000
// 100,000 * 10 / 7000 = (145 turns = 145 / (4 + 2) = 24 rounds)
// round takes roughly 1 minutes = 24 minutes
// round:
//  => pc => player1 attacks monster1
//  => item -> onRoundStart addEventHandler w/ {n charges} to equipper
//    => onEndOfTurn (25% chance to not consume turn)
//  => monster1 stuns player2
//  => monster1 25% chance to go again
//  => pc => player3 does something here
//  => monster4 responds to player3 action...
//  => pc => player2 skips turn (stunned!)
//  => monster2 attacks player1
//  => pc => player3 attacks monster1
//  => monster3 attack player1
// round lasts until characters run out of turns
// player chooses character and action...
// "random" monster responds to player action
// round: [
//  => player1
//  => player3
//  => monster1
//  => player2
//  => monster2
//  => player3
//  => monster4
//  => monster3
//  ]
